import { ScrollReveal } from "@/components/base/ScrollReveal";

const steps = [
  {
    no: "01",
    title: "お問い合わせ",
    desc: "電話・フォームから、現地住所と工事内容をお気軽にご相談ください。",
    icon: "ri-chat-3-line",
  },
  {
    no: "02",
    title: "現地調査・お見積り",
    desc: "最短即日で現地調査を実施。明朗な見積書をご提示します。",
    icon: "ri-file-list-3-line",
  },
  {
    no: "03",
    title: "ご契約・工事スケジュール",
    desc: "ご契約後、最適な工事スケジュールをご提案。日程を調整します。",
    icon: "ri-calendar-check-line",
  },
  {
    no: "04",
    title: "施工・お引き渡し",
    desc: "経験豊富な職人が施工。完了後の確認とアフターフォローまで一貫対応。",
    icon: "ri-tools-fill",
  },
];

export default function Process() {
  return (
    <section className="relative bg-secondary-50/40 py-20 md:py-32 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="w-10 h-px bg-secondary-500"></span>
            <span className="text-xs tracking-[0.3em] uppercase text-secondary-700 font-medium">
              Process
            </span>
            <span className="w-10 h-px bg-secondary-500"></span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            ご依頼の流れ
          </h2>
        </div>

        <ScrollReveal direction="up" stagger threshold={0.03} rootMargin="0px 0px -10px 0px">
          <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {/* Connecting line (desktop) */}
            <div className="hidden lg:block absolute left-0 right-0 top-[88px] h-px bg-gradient-to-r from-transparent via-secondary-300 to-transparent"></div>

            {steps.map((s) => (
              <div
                key={s.no}
                className="relative bg-background-50 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-secondary-400 transition-colors"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="w-16 h-16 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className={`${s.icon} text-secondary-700 text-2xl`}></i>
                  </span>
                  <span className="font-heading text-4xl font-bold text-secondary-200">
                    {s.no}
                  </span>
                </div>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">
                  {s.title}
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}